import { AxiosRequestConfig } from "axios";
import { BriaAxios } from "../config/axios.tsx";

class QueryService {
	private baseURL: string;
	private customAxiosBaseUrl?: string;
	private hideToastError?: boolean;

	constructor(baseURL: string, hideToastError?: boolean, customAxiosBaseUrl?: string) {
		this.baseURL = baseURL;
		this.customAxiosBaseUrl = customAxiosBaseUrl;
		this.hideToastError = hideToastError;
	}

	async get(url: string, config?: AxiosRequestConfig<any>): Promise<any> {
		const response = await (
			await BriaAxios(config?.headers, config?.signal as AbortSignal, undefined, this.customAxiosBaseUrl)
		).get(`${this.baseURL}${url}`, config);
		return response.data;
	}

	async post(
		url: string,
		data: any = {},
		headers: Record<string, string> = {},
		options: Record<string, any> = {},
	): Promise<any> {
		const config = { ...options, headers: { ...headers } };

		const response = await (
			await BriaAxios(config?.headers, undefined, this.hideToastError, this.customAxiosBaseUrl)
		).post(`${this.baseURL}${url}`, data, config);
		return response.data;
	}

	async put(url: string, data: any = {}): Promise<any> {
		const response = await (
			await BriaAxios(undefined, undefined, undefined, this.customAxiosBaseUrl)
		).put(`${this.baseURL}${url}`, data);
		return response.data;
	}

	async patch(url: string, data: any = {}): Promise<any> {
		const response = await (
			await BriaAxios(undefined, undefined, undefined, this.customAxiosBaseUrl)
		).patch(`${this.baseURL}${url}`, data);
		return response.data;
	}

	async delete(url: string): Promise<any> {
		const response = await (
			await BriaAxios(undefined, undefined, undefined, this.customAxiosBaseUrl)
		).delete(`${this.baseURL}${url}`);
		return response.data;
	}
}

export default QueryService;
